import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { checkCategoryProperties, saveProduct } from 'redux/product'
import ProductEdit from './ProductEdit'

const mapStateToProps = (state, ownProps) => {
  const { importProduct, product } = state.product
  return { importProduct, product }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      saveProduct,
      checkCategoryProperties,
    },
    dispatch
  )
}

class ProductCompare extends React.Component {
  render() {
    const { importProduct, product } = this.props
    const { saveProduct } = this.props
    return (
      <ProductEdit
        kind="compare"
        product={product}
        compareProduct={importProduct}
        onSave={saveProduct}
        form={'product_compare_form'}
        tabs={['generic', 'properties', 'todos', 'specialitems']}
      />
    )
  }
}

ProductCompare = connect(mapStateToProps, mapDispatchToProps)(ProductCompare)
export default ProductCompare



// WEBPACK FOOTER //
// ./src/components/admin/Products/ProductCompare.jsx